import * as React from 'react';

import useChat from '../hooks/useChat';

interface ErrorFailedToSendProps extends React.HTMLProps<HTMLDivElement> {
	messageId: string;
}

export const ErrorFailedToSend: React.FC<ErrorFailedToSendProps> = ({
	messageId,
}) => {
	const { resendMessage } = useChat();

	return (
		<div
			data-testid="failed-to-send"
			data-tag-area="message failed to send"
			className="text-caption text-error pt-2"
		>
			<span className="text-caption text-error">Failed to send. </span>
			<button
				className="text-error p-0 text-xs font-bold underline bg-transparent cursor-pointer"
				data-testid="retry-sending-message-cta"
				type="button"
				data-tag-name="retry sending message cta"
				data-tag-message-id={messageId}
				onClick={() => {
					resendMessage(messageId);
				}}
			>
				Retry
			</button>{' '}
		</div>
	);
};

export default ErrorFailedToSend;
